import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { convertImage } from 'appSrc/utils';
import { Icon, InfiniteTable } from 'appSrc/components/UI';
import TextTruncate from 'react-text-truncate';
import style from './styles/style.module.css';

class InfiniteProductsTable extends PureComponent {
    constructor( props ) {
        super( props );
    }
    submitProduct = ( product ) => {
        this.props.onSubmit( product );
    }


    render() {
        const { products } = this.props;

        return (
            <div>
                <InfiniteTable
                className={ style.productsTable }
                loadMore={ this.props.loadMore }
                elementHeight={ 90 }>
                    { this.arrayTableRows( products ) }
                </InfiniteTable>
            </div>
        );
    }

    arrayTableRows = ( products ) => {
        var markedIds = this.props.markedProducts.map( product => product.desireid );
        var rows = products.map( ( product ) => {
            return (
                <InfiniteTable.Row key={ product.desireid } className='dl-table-body'>
                    <InfiniteTable.Cell className={ style.coverImage }>
                        <img src={ convertImage( product.image, '/100x100' ) } />
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <TextTruncate
                        line={ 2 }
                        text={ product.title } />
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <TextTruncate
                        line={ 2 }
                        text={ product.author.displayName } />
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        { product.featured !== null ? ( <Icon source='fontAwesome' icon='fas/faCheck' style={ { color: 'inheirit' } } /> ) : null }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        { markedIds.includes( product.desireid ) ?
                            'Added'
                            :
                            <Icon source='fontAwesome' className='dropdown' icon='fas/faPlus' style={ { color: '#6461ec', cursor: 'pointer' } } faSize='2x' onClick={ () => { this.submitProduct( product ); } } />
                        }
                    </InfiniteTable.Cell>
                </InfiniteTable.Row>
            );
        } );

        rows.unshift( (
            <InfiniteTable.Row key='-1' className='dl-table-head'>
                <InfiniteTable.Cell></InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    PRODUCT TITLE
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    USER
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    FEATURED
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>ADD</InfiniteTable.Cell>
            </InfiniteTable.Row>
        ) );

        return rows;
    }
}
InfiniteProductsTable.defaultProps = {
    onProductUpdated: ()=>{},
};

export default connect()( InfiniteProductsTable );
